import {
  SET_ACTIVE_TAB,
  SET_CATALOGUE_SELECTIONS,
  SET_EQUIPMENT,
  SET_ERROR_CODE,
} from './types'

const setJobActiveTab = payload => ({ type: SET_ACTIVE_TAB, payload })

const setEquipmentData =
  (payload, index = 0) =>
  (dispatch, getState) => {
    const equipmentState = getState()?.jobs?.equipment
    const updatedSelected = [...(equipmentState?.selected || [])]
    updatedSelected[index] = { ...updatedSelected[index], ...payload }
    dispatch({
      type: SET_EQUIPMENT,
      payload: { selected: updatedSelected },
    })
  }

const setEquipmentOptions = payload => ({ type: SET_EQUIPMENT, payload })

const setErrorCodeData = payload => ({ type: SET_ERROR_CODE, payload })

const setSelectedCatalogue = payload => ({
  type: SET_CATALOGUE_SELECTIONS,
  payload,
})

export {
  setJobActiveTab,
  setEquipmentData,
  setErrorCodeData,
  setSelectedCatalogue,
  setEquipmentOptions,
}
